import React from "react";
import Icon, { IconsVariant } from "../Icon/Icon";
import { cn } from "@/shared/utils/cn";
interface InnerProps {
  variants?: IconsVariant;
  children: React.ReactNode;
  selected?: boolean;
}

const Inner = ({
  selected,
  children,
  variants = "objectgroup",
}: InnerProps) => {
  return (
    <div
      className={cn(
        "cursor-pointer flex flex-col items-center bg-white gap-2",
        selected ? "text-primary" : "text-text"
      )}
    >
      <Icon
        className={cn("h-8 w-8", selected ? "fill-primary" : "fill-text")}
        variants={variants}
      />
      <div
        className={cn(
          "hidden md:block",
          selected ? "text-primary" : "text-text"
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Inner;
